import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import CreditReadiness from "@/pages/CreditReadiness";

export const Route = createFileRoute("/credit-readiness")({
  head: () => seoHead("/credit-readiness"),
  component: CreditReadiness,
});
